/** The landing page's two scroll targets, named where both ends can see them. */
export const SIGNUP_SECTION_ID = "signup";
export const FEATURED_SECTION_ID = "featured";

/**
 * Move the landing page to one of its sections.
 *
 * Not an `<a href="#signup">`: a fragment link writes the hash into the URL, and
 * the router's history entries carry the stacks state that `HistorySync`
 * restores — a bare hash entry there has none, and going back through it is a
 * navigation to nowhere. Scrolling by hand leaves the URL alone.
 */
export function scrollToLandingSection(id: string) {
  const target = document.getElementById(id);
  if (!target) return;
  target.scrollIntoView({
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "smooth",
    block: "start",
  });
}
